export default __webpack_public_path__ + "media/zeeMedia.44e10c68.png";